module.exports = __webpack_public_path__ + "static/img-people-monitoring@2x.1ba5dad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-people-monitoring@2x.png
// module id = 798
// module chunks = 199482085584678